import React from 'react';
import { Quote } from 'lucide-react';
export function ProofSection() {
  return <section className="py-12 md:py-16 bg-gradient-to-b from-[#0f1623] to-[#0a0e1a]" data-id="element-204">
      <div className="container mx-auto px-4" data-id="element-205">
        <div className="max-w-4xl mx-auto text-center" data-id="element-206">
          <Quote className="h-12 w-12 text-[#00d4aa] mx-auto mb-6 opacity-50" data-id="element-207" />
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-8 leading-tight" data-id="element-208">
            En solo 7 días, tu hijo dejará de preguntarte{' '}
            <span className="text-[#f59e0b]" data-id="element-209">"¿puedo jugar más?"</span> para
            decirte{' '}
            <span className="text-[#00d4aa]" data-id="element-210">"mira el código que escribí"</span>
            .
          </h2>
          <p className="text-xl text-gray-300" data-id="element-211">
            Pasarás de ser el policía de las pantallas a ser el socio de
            lanzamiento de su primer mini-juego publicado.
          </p>
        </div>
      </div>
    </section>;
}